<template>
    <div :id="id"
         class="material-select-vuejs"
         ref="materialSelectMenu"
    >
        <!--show to select list available-->
        <transition data-ref="the material selector modal"
                    name="fade">
            <div v-show="show"
                 class="material-select-vuejs--selector bg-level-5 z-depth-2"
                 ref="theSelector"
            >
                <!--the search element-->
                <div v-if="params.showSearch"
                     :id="search_element.id"
                     class="md-form material-select-vuejs--selector-search">
                    <i class="fa prefix fa-search" :class="setIconClass()"></i>
                    <input type="text"
                           :id="search_element.id"
                           v-model="search_element.result"
                           class="form-control material-select-vuejs--search-value"
                           title="material-select-vuejs--search-value">
                    <div v-on:click="show = false"
                         aria-label="Close"
                         class="close">
                            <span aria-hidden="true">
                                <i class="material-icons">close</i>
                            </span>
                    </div>
                </div>

                <!--submit button-->
                <transition name="expandTopLeftDown">
                    <template v-if="params.submitAction.active == true && params.submitAction.show == true">
                        <div v-on:click="submit()" class="d-flex btn btn-primary">
                            <span class="m-auto">{{params.submitAction.text}}</span>
                        </div>
                    </template>
                </transition>
                <!--the group select element-->
                <div v-if="isGrouped()"
                     class="material-select-vuejs--selector--results"
                     data-grouped="isGrouped">
                    <div :id="list_element.id">
                        <div v-if="params.link.add"
                             class="material-select-vuejs--list-item-link">
                            <template v-if="params.link.icon != ''">
                                <div class="btn btn-secondary d-flex"
                                     v-on:click="clickedLink()">
                                        <span class="m-auto"><i class="fa"
                                                                :class="params.link.icon"
                                                                aria-hidden="true"></i>
                                        {{params.link.text}}</span>
                                </div>
                            </template>
                            <template v-else>
                                <div class="btn btn-small btn-secondary d-flex"
                                     v-on:click="clickedLink()">
                                    {{params.link.text}}
                                </div>
                            </template>
                        </div>
                        <!--create each group-->
                        <div class="material-select-vuejs--groups"
                             v-for="group in params.grouped">

                            <!--<div class="hr-sect">{{group}}</div>-->
                            <div class="material-select-vuejs--groups-title">{{group}}</div>
                            <div class="material-select-vuejs--groups-item"
                                 :id="createItemId(select_item.optionValue)"
                                 v-for="select_item in filteredItems"
                                 v-if="select_item[params.group_by] == group"
                                 v-on:click="itemSelected(select_item)"
                                 :class="[{
                                 'item-selected':select_item.selected

                                 },itemSelectedClass(select_item)]"
                            >
                                <span class="filterable">{{select_item.title}}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-else
                     class="material-select-vuejs--selector--results"
                     data-grouped="!isGrouped">
                    <div :id="list_element.id">
                        <!--external links-->
                        <div v-if="params.link.add" class="material-select-vuejs--list-item-link">
                            <div v-if="params.link.icon != ''">
                                <div class="btn btn-secondary" v-on:click="clickedLink()">
                                    <i class="fa" :class="params.link.icon" aria-hidden="true"></i>
                                    {{params.link.text}}
                                </div>
                            </div>
                            <div v-else>
                                <div v-on:click="clickedLink()"
                                     class="btn btn-small btn-primary"></div>
                            </div>
                        </div>
                        <!--show title-->
                        <div v-if="(params.top_option.title.length > 0)"
                             v-on:click="show=false"
                             class="material-select-vuejs--list-title hr-sect"
                        >
                            {{params.top_option.title}}
                        </div>
                        <!--create preview element-->
                        <div class="material-select-vuejs--list-item"
                             :id="createItemId(select_item.optionValue)"
                             v-for="select_item in filteredItems"
                             v-on:click="itemSelected(select_item)"
                             :class="[{
                                 'item-selected':select_item.selected

                                 },itemSelectedClass(select_item)]"
                        >
                            <div class="d-flex start"
                                 :class="{
                                    'align-items-center ':!select_item.icon_class || select_item.icon_class == null,
                                    'align-items-top':select_item.icon_class
                                }"
                            >
                                <i v-if="select_item.icon_class"
                                   :class="select_item.icon_class"
                                   class="pl-1"
                                ></i>

                                <span class="filterable text-right">{{select_item.title}}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </transition>
        <div class="material-select-vuejs--dropdown">
            <div class="material-select-vuejs--dropdown-input">
                <span class="material-select-vuejs--dropdown-input-caret">▼</span>
                <input v-on:click="toggleMenu()"
                       data-ref="selected-preview"
                       class="material-select-vuejs--dropdown-input-value form-control"
                       type="text"
                       :tabindex="tabindex"
                       :title="title"
                       v-tooltips-enabled="{
                        active:tool_tip_active,
                        title:title
                    }"
                       v-model="params.placeholder"
                >
            </div>
        </div>
        <!--native select element-->
        <select :name="params.selected_input_name"
                :required="params.required"
                :id="select_element.id"
                :data-ref="select_element.id"
                class="material-select-vuejs--select colorful-select dropdown-primary "
                :multiple="params.multiple"
                title="selected_input_name">

            <option value="" disabled="" selected="">{{params.top_option.title}}</option>
            <option v-model="select_item.optionValue"
                    :selected="select_item.selected"
                    :value="select_item.optionValue"
                    v-for="select_item in filteredItems ">
                {{select_item.title}}
            </option>
        </select>
        <label v-if="params.label!= ''"
               class="material-select-vuejs--label"
               :for="select_element.id">{{params.label}}</label>
        <BaseBackgroundOverlay :show="show"></BaseBackgroundOverlay>
    </div>
</template>

<script>
    import Vue from 'vue';
    import {BREAKPOINT} from '../../../config';
    import vueTooltip from '../../../../../../app/Shared/Resources/Assets/js/components/base/tooltip/vueTooltip';

    Vue.use(vueTooltip);
    import lang from '../../../../../../app/Shared/Resources/Assets/js/helpers/lang';
    import {uniqueId} from '../../../helpers/classesAndIds';
    import {_} from 'underscore';

    export default {
        props: [
            'id',
            'content',
            'required',
            'tooltip',
            'title',
            'tabindex',
            'select_input_id'
        ],
        data() {
            return {
                thisElement:null,
                // id: null,
                tool_tip_active: true,
                tool_tip_toggle: true,
                emit_controller: 'material_select',
                show: false,
                input_width: '',
                params: {
                    // this will provide a submit button to the select list but will also disable the itemSelected $emit
                    submitAction: {
                        active: false,
                        emit_path: 'material_select_submit',
                        text: 'submit',
                        show: false,
                    },
                    emit_path: 'material_select_result',
                    init_from_parent: false,
                    showSearch: true,
                    link: {
                        add: false,
                        url: '#',
                        icon: 'fa fa-plus'
                    },
                    disabledClass: '',
                    selectedClass: '',
                    multiple: false,
                    grouped: [],
                    group_by: null,
                    top_option: {
                        title: 'Choose your option'
                    },
                    selected_input_name: '',
                    label: '',
                    placeholder: '',
                    required: false,
                    search_icon: 'fa-search'
                },
                placeholder_original: '',
                select_items: [],
                search_element: {
                    id: uniqueId(this._uid + '-search_element'),
                    title: 'Find...',
                    result: ''
                },
                list_element: {
                    id: uniqueId(this._uid + '-list_element'),
                    item_id_prepend: this._uid + '-selected-item--',
                    item_selected_class: 'item-selected',
                    item_disabled_class: 'disabled',
                },
                select_element: {
                    id: null
                },
                selector: {
                    top: 0,
                    original: 0
                }
            }
        },
        /**
         * parent parses the content for the input select fields and applies the
         * content to the select_items list
         */
        mounted() {
            let self = this;
            //console.log('This Vue instance is mounted at element:', this.thisElement);

            if (typeof self.content !== 'undefined' && self.content !== null) {
                if (typeof self.content.emit_controller !== 'undefined' && self.content.emit_controller !== null) {
                    self.emit_controller = self.content.emit_controller;
                }
            }
            self.tool_tip_active = self.tooltip;
            /**
             * When self receives data we can then populate the search panel with details
             */
            self.$root.$on(self.emit_controller, data => {
                // console.log('updating',data);
                self.updateMenu(data);
//                console.log(' _this.select_items', _this.select_items);
            });

            if (typeof self.required !== 'undefined' && self.required !== null) {
                self.params.required = self.required;
            }
            self.$nextTick(function () {
                if (typeof self.select_input_id !== 'undefined' && self.select_input_id !== null) {
                    self.select_element.id = self.select_input_id;
                } else {
                    self.select_element.id = uniqueId(self._uid + '-select_element')

                }
                if (self.select_element == 'event--crud-tags') {
                    console.log('self.select_element', self.select_element)

                }
                //console.log('self.select_input_id',self.select_input_id)
            })

//            self.$refs.search.focus();
        },
        watch: {
            select_items: function (items) {
                // console.log('items watched', items);
            },
            tooltip(i) {
                this.tool_tip_active = this.tool_tip_toggle = i;
            },
            show(show) {
                // is the tooltip controller active and select is showing
                if (show && this.tool_tip_toggle) {
                    this.tool_tip_active = false;
                } else if (!show && this.tool_tip_toggle) {
                    this.tool_tip_active = true
                }
            }
        },
        methods: {
            log(...args) {
                console.log('args', args);
            },
            submit() {
                let selectedItems = _.where(this.select_items, {
                    selected: true
                });

                if (this.params.init_from_parent === true) {
                    this.$parent.$emit(this.params.submitAction.emit_path, selectedItems);
                } else {
                    this.$emit(this.params.submitAction.emit_path, selectedItems);
                }
                // clear selected preview and list
                this.unSelectItems();
                // hide the list preview
                this.show = false;
            },
            setIconClass() {
                let active = (this.search_element.result.length > 0) ? 'active' : null;
                let icon = this.params.search_icon;
                return active + ' ' + icon;
            },
            /**
             * User toggled the menu by clicking on the input preview
             */
            toggleMenu() {
                this.repositionSelector(this.show = !this.show);
            },
            repositionSelector() {
                let self = this;

                if (this.show && BREAKPOINT.current() != 'xs') {
                    this.$nextTick(function () {
                        let nearTop = 0,
                            nearBottom = 100,
                            window_height = document.documentElement.clientHeight,

                            parent = self.$refs.materialSelectMenu.getBoundingClientRect(),
                            selector_height = self.$refs.theSelector.getBoundingClientRect().height;
// console.log('parent.bottom + selector_height',parent.bottom + selector_height)
                        // if the item/part of item is rendered below the bottom of the viewport
                        if (parent.bottom + selector_height > window_height) {

                            //will the placed selector top be too far up?
                            let offset = (selector_height > parent.top) ? parent.top : selector_height;

                            if (offset > 0) {
                                offset = offset * -1;
                            }
                            self.selector.top = offset + 'px';
                            // self.$refs.theSelector.style.top = self.selector.top;
                        } else {
                            // reset the top position
                            self.$refs.theSelector.style.top = null;
                        }

                    });
                } else {

                }
            },
            addAndSelect(item) {
                let _this = this,
                    new_item = {
                        title: lang('title', item.lang),
                        optionValue: item.id,
                        selected: true
                    };

                if (_this.params.grouped.length > 0) {
                    new_item[_this.params.group_by] = item[_this.params.group_by];
                }

                _this.select_items.push(new_item);
                _this.populatePreview();
            },

            /**
             * @param data.params
             * @param {Array} data.select_items
             * @param data
             * */
            updateMenu(data) {
                let self = this;

                if ('params' in data) {
                    self.params = _.extendOwn(self.params, data.params);
                }
                self.select_items = [];
                self.placeholder_original = self.params.placeholder;

                for (let key in data.select_items) {

                    let item = {
                        title: lang('title', data.select_items[key].lang),
                        optionValue: data.select_items[key].id,
                        selected: ('selected' in data.select_items[key]) ? data.select_items[key].selected : false
                    };

                    /**
                     * Add icon class if set
                     */
                    if (data.select_items[key].icon_class) {
                        item.icon_class = data.select_items[key].icon_class;
                    }

                    if (self.params.grouped.length > 0) {
                        item[self.params.group_by] = data.select_items[key][self.params.group_by];
                    }
                    self.select_items.push(item);
                }
                // console.log('self.params', self.params);
                self.populatePreview();
            },
            itemSelectedClass(item) {
                if (item.selected === true) {
                    return this.list_element.item_selected_class
                } else {
                    return null;
                }
            },
            /**
             * An item was selected
             * */
            itemSelected(item) {
// console.log('itemSelected');
                item.selected = !item.selected;

                // clone the selected item value so it doesn't change after resetting all
                let theSelected = item.selected;

                /**
                 * If single selection only. Un select all
                 */
                if (!this.isMultiple()) {
                    this.unSelectItems();
                }
                // update the selected item value post un setting all
                item.selected = theSelected;

                // update the selection box to show items selected
                let list = this.populatePreview();

                // hide the menu when not using multiple select
                if (!this.isMultiple()) {
                    this.show = false;
                }

                // emit only if the submit action is not active
                if (!this.params.submitAction.active) {
                    if (this.params.init_from_parent === true) {
                        this.$parent.$emit(this.params.emit_path, list);
                    } else {
                        this.$emit(this.params.emit_path, list);
                    }
                }
            },
            /**
             * Un select all items that were previously selected
             * */
            unSelectItems() {

                this.select_items.forEach(function (listItem) {
                    listItem.selected = false;
                });
            },
            /**
             * Updates the preview os selected items
             * */
            populatePreview() {
                let list = {
                    titles: [],
                    items: []
                };

                this.select_items.forEach(function (listItem) {
                    if (listItem.selected) {
                        list.titles.push(listItem.title);
                        list.items.push(listItem);

                    }
                });

                if (list.titles.length > 0) {
                    this.params.placeholder = list.titles;
                    this.params.submitAction.show = true;
                    return list.items;
                } else {
                    this.params.submitAction.show = false;
                    this.params.placeholder = this.placeholder_original;
                    return [];
                }
            },
            /**
             * Creates a unique id for the individual item
             * */
            createItemId(theValue) {
                return this.list_element.item_id_prepend + theValue
            },
            /**
             * Creates a unique id
             */
            createId() {
                return uniqueId(this._uid + '-select-item--')
            },

            clickedLink() {
                if (this.params.link.url === '') {
                    this.$emit('material_select_link_click', true);
                    this.show = false;
                } else {
                    window.location.href = this.params.link.url;
                }
            },
            /**
             * Checks if its a multiple select
             * @returns {boolean}
             */
            isMultiple() {
                return this.params.multiple === true;
            },
            /**
             * Checks if its a grouped select
             * @returns {boolean}
             */
            isGrouped() {
                return this.params.grouped.length > 0;
            },
            /**
             * processes clicks on document
             * @param elementClicked the document
             */
            documentClick(elementClicked) {
                // let el = this.$el;
                //
                // //
                // if (el !== elementClicked.target) {
                //     this.show = false
                // }
                // console.log('this.show', this.show)
            },
            /**
             * processes keydown events
             * @param e
             */
            documentKeyDown(e) {
                //escape key pressed
                if (this.show && e.keyCode == 27) {
                    this.show = false;
                }
            }
        },
        destroyed() {
            // document.removeEventListener('click', this.documentClick);
            document.removeEventListener("keydown", this.documentKeyDown);
        },
        created() {
            // document.addEventListener('click', this.documentClick);
            document.addEventListener("keydown", this.documentKeyDown);
        },

        computed: {
            // A computed property that holds only those items that match the searchString.
            filteredItems: function () {
                let items_array = this.select_items,
                    searchString = this.search_element.result,
                    _this = this;

                if (!searchString) {
                    return items_array;
                }

                searchString = searchString.trim().toLowerCase();

                items_array = items_array.filter(function (item) {

                    if (_this.isGrouped()) {
                        if (typeof item[_this.params.group_by] !== 'undefined') {
                            // get the current items group type
                            if (item[_this.params.group_by].toLowerCase().indexOf(searchString) !== -1) {
                                return item;
                            }
                        }
                    }

                    if (item.title.toLowerCase().indexOf(searchString) !== -1) {
                        return item;
                    }
                });

                // Return an array with the filtered data.
                return items_array;
            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/forms/select/MaterialSelect.vue?286b7030